import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../../../../selectors/layout';
import { ServicesLayoutDesktop } from './components/ServicesLayoutDesktop/ServicesLayoutDesktop';
import { IServicesLayoutProps } from './types';
import { ServicesLayoutMobile } from './components/ServicesLayoutMobile/ServicesLayoutMobile';

export const ServicesLayout = (props: IServicesLayoutProps) => {
  const isMobile = useSelector(selectIsMobileLayout);

  return isMobile ? <ServicesLayoutMobile {...props} /> : <ServicesLayoutDesktop {...props} />;
};
